/**
 * @license
 * Copyright (c) 2018 Crius Authors. All rights reserved.
 */

import '@polymer/polymer/polymer-element.js';

const $_documentContainer = document.createElement('template');
$_documentContainer.innerHTML = `<dom-module id="cs-social-button-shared-styles">
<template strip-whitespace="">
  <style>
    .cspl-social-button {
      align-items: center;
      background: transparent;
      border-radius: 50%;
      cursor: pointer;
      display: inline-flex;
      height: 40px;
      justify-content: center;
      list-style: none;
      width: 40px;
    }

    .cspl-social-button:hover {
      transform: scale(1.1);
      transition: transform var(--cs-interface-expansion) linear;
    }

    .cspl-social-button iron-icon {
      height: 16px;
      width: 16px;
    }
  </style>
</template>
</dom-module>`;

document.head.appendChild($_documentContainer.content);
